import { createStore, createHook, createActionsHook, type Action } from 'react-sweet-state';

interface State {
	blankets: Record<string, boolean>;
	isPolling: boolean;
}

const initialState: State = {
	blankets: {},
	isPolling: false,
};

const actions = {
	showBlanket:
		(entryPointId: string): Action<State> =>
		({ setState, getState }) => {
			const { blankets } = getState();
			setState({ blankets: { ...blankets, [entryPointId]: true } });
		},
	hideBlanket:
		(): Action<State> =>
		({ setState }) => {
			setState({ blankets: {}, isPolling: false });
		},
	setIsPollingStatus:
		(isPolling: boolean): Action<State> =>
		({ setState }) =>
			setState({ isPolling }),
} as const;

type Actions = typeof actions;

const store = createStore<State, Actions>({
	name: 'confluence-loom-utils.loom-recorder-loading-blanket',
	initialState,
	actions,
});

export const useLoomRecorderLoadingBlanket = createHook(store);
export const useLoomRecorderLoadingBlanketActions = createActionsHook(store);

/**
 * @param entryPointId
 * @returns object containing whether the blanket is shown and whether it is actively polling
 */
export const useIsLoomRecorderLoadingBlanketShown = (entryPointId: string) => {
	const [{ blankets, isPolling }] = useLoomRecorderLoadingBlanket();
	const isBlanketShown = !!blankets[entryPointId];
	return { isBlanketShown, isPolling };
};
